function extractElementName(src) {
    // Extract the part after the first '/' and before the last two '.'
    const match = src.match(/\/([^/.]+)\.[^/.]+\.[^/.]+$/);
    if (match) {
        return match[1];
    }
    return null;
}

module.exports = extractElementName;